<template>
  <v-app light>
    <notifications position="top center" class="notification" />
    <v-navigation-drawer v-model="sidebar" class="d-md-none d-lg-none" absolute temporary>
      <v-list>
        <v-list-item v-for="item in userMenu" :key="item.title" :to="item.path">
          <v-list-item-action>
            <!-- <v-icon>{{ item.icon }}</v-icon> -->
          </v-list-item-action>
          <v-list-item-content>{{ item.title }}</v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app height="80" dark :class="navbarColorClass">
      <span class="hidden-md-and-up">
        <v-app-bar-nav-icon @click="sidebar = !sidebar"></v-app-bar-nav-icon>
      </span>
      <v-toolbar-title class="white--text">
        <router-link to="/" class="white--text">
          <v-img :src="'../images/cefori-small-logo.png'" max-height="60" contain></v-img>
        </router-link>
      </v-toolbar-title>
      <v-toolbar-title class="grey--text" v-if="userName">
        Bienvenu
        <span class="font-italic">{{ userName }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn v-for="item in userMenu" :key="item.title" :to="item.path" :class="navbarColorClass" elevation="0">
          {{ item.title }}
        </v-btn>
      </v-toolbar-items>

      <v-card-title class="white--text">
        <span class="text-h5"></span>
        <v-spacer></v-spacer>
        <v-menu transition="slide-y-transition" offset-y bottom left>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" dark icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item>
              <v-btn color="green" dark to="/my-profile" block>
                <v-icon dark left>mdi-account-circle</v-icon>
                Profil
              </v-btn>
            </v-list-item>
            <v-list-item v-if="isAdmin">
              <v-btn color="purple" dark to="/export" block>
                <v-icon dark left>mdi-database-export</v-icon>
                Export
              </v-btn>
            </v-list-item>
            <v-list-item v-if="isAdmin">
              <v-btn color="teal" dark to="/descriptions" block>
                <v-icon dark left>mdi-view-list</v-icon>
                Descriptions
              </v-btn>
            </v-list-item>
            <v-list-item>
              <v-btn color="red lighten-2" dark block>
                <v-icon dark left>mdi-logout-variant</v-icon>
                <a class="white--text link" @click="logout()">se déconnecter</a>
              </v-btn>
            </v-list-item>
            <div class="version">{{ version }}</div>
          </v-list>
        </v-menu>
      </v-card-title>
    </v-app-bar>
    <v-main>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex"
import { updateRoles } from "@/services/auth"
import ConnectedUser from "@/models/ConnectedUser"
import Description from "@/models/Description"

export default {
  data() {
    return {
      sidebar: false,
      version: "",
      menuItems: [
        { title: "Cours", path: "/courses", permissionCheck: false },
        { title: "Présences", path: "/presences", permissionCheck: false },
        { title: "Etudiants", path: "/students", permissionCheck: false },
        { title: "Flux", path: "/flux", permissionCheck: false },
        { title: "Session", path: "/session", permissionCheck: true },
        { title: "Référents", path: "/assistants", permissionCheck: true },
        { title: "Personnel", path: "/users", permissionCheck: true },
      ],
    }
  },
  computed: {
    ...mapGetters("Auth", ["isAdmin"]),
    userMenu: function () {
      return this.menuItems.filter((i) => i.permissionCheck == false || (i.permissionCheck && this.isAdmin))
    },
    userName: function () {
      return ConnectedUser.query().first()?.name
    },
    navbarColorClass: function () {
      const env = window.Laravel?.appEnv || 'production'
      switch (env) {
        case 'local':
          return 'green darken-2'
        case 'staging':
          return 'blue darken-2'
        default:
          return 'purple darken-4'
      }
    },
  },
  methods: {
    async logout() {
      try {
        // Call logout endpoint
        await axios.post('/logout')
        // clear all stores
        this.$store.dispatch('entities/deleteAll')
        // Redirect to login page
        window.location.href = '/login'
      } catch (error) {
        console.error('Logout failed:', error)
        // Force redirect even if logout fails
        window.location.href = '/login'
      }
    },
  },
  async mounted() {
    await ConnectedUser.getSelfProfile()
    await updateRoles()
    await axios.get("/api/v1/version").then((response) => {
      const versionData = response.data.data
      const buildDate = versionData.build_date && versionData.build_date !== "unknown"
        ? new Date(versionData.build_date).toLocaleDateString("fr-CH")
        : ""
      this.version = `v_${versionData.version}.${versionData.build} ${buildDate}`.trim()
    })
    Description.getDescriptions()
  },
}
</script>
<style>
.link {
  text-decoration: none;
}

.notification {
  min-width: 200px;
  margin: 50px;
}

.spacy {
  white-space: nowrap;
}

.version {
  font-size: 0.6rem;
  margin: 5px;
  float: right;
}

.v-menu__content {
  background-color: white !important;
}

</style>
